<div *ngIf="isLoading | async" class="overlay">
  <div class="spinner-container">
    <div class="spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
  </div>
</div>
